import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { OverviewMobxDto } from '../../../../../../models/mobx/dtos/statistic/overview-mobx-dto';

interface CardUpdatedInterface {
    fields?: (keyof OverviewMobxDto)[];
    children: React.ReactNode;
}

export const CardDashboardTradesLoading: React.FC<CardUpdatedInterface> = observer(({ children, fields }) => {
    const theme = useTheme();
    const { statisticStore } = useRootStore();
    const { overviewStore } = useRootStore().statisticStore;

    const animationComponent: React.ReactNode = useMemo(() => {
        if (!statisticStore.loading && fields && fields.length > 0) {
            let shouldAnimate = false;
            fields.map((field) => {
                if (overviewStore.getIsFieldDirty(field)) {
                    shouldAnimate = true;
                }
                return null;
            });
            if (shouldAnimate) {
                overviewStore.removeDirtyFieldsWithDelay();
                return (
                    <div
                        className="absolute inset-0 z-[999] rounded-large"
                        style={{
                            backgroundColor: theme.palette.color.note.main,
                            animation: 'card-dashboard-trades-loading-fade-background 1s ease-in-out 1',
                        }}
                    />
                );
            }
            return null;
        }
        return null;
    }, [statisticStore.loading, overviewStore.overview, fields, overviewStore.overviewDirtyFields, theme]);

    return (
        <div className="relative min-h-[18rem] h-full w-full flex-1">
            <style>
                {`@keyframes card-dashboard-trades-loading-fade-background {
                    from {
                        opacity: 0.3;
                    }
                    to {
                        opacity: 0;
                    }
                }`}
            </style>
            {animationComponent}
            {children}
        </div>
    );
});
